import { messages } from 'default/translated_text'

export function t(key){
  return(messages[window.locale][key] || messages['en'][key])
}
